/*
 * Copyright (c) 2024. Tooling Team
 */

import { Link } from "@uhg-abyss/web/ui/Link";
import { MintHeader } from "../navigation/MintHeader";

export const LoggedOut = () => (
  <div>
    <MintHeader globalNav={false}></MintHeader>
    <div className="logged-out">
      <h1>Logged Out</h1>
      {/* Plain href (full page load) so "/" re-runs the PrivateRoute sign-in */}
      <Link href="/">Click here to log back in</Link>
    </div>
  </div>
);
